export default "__VITE_ASSET__BfUMRfdV__"